import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import UpgradeSubscriptionModal from 'modules/billing/components/UpgradeSubscriptionModal'

const UpgradeSubscriptionModalPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.plans.fullPath())
  }

  return <UpgradeSubscriptionModal onClose={onClose} />
}

export default UpgradeSubscriptionModalPage
